import type { FaireProductEntity } from "../../entity_types/product";

export const p_uwt9nktqjm: FaireProductEntity = {
  token: "p_uwt9nktqjm",
  type: "product",
  name: "BP740 | French Terry Jogger Pants",
  brandToken: "b_395xq4ekla",
  brandName: "By Together",
  imageUrl:
    "https://cdn.faire.com/fastly/e61b2893f117aa8dfb775f45e5d205c4f61eb998d1d23b844b09549d3ac47a4b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c61bf0e0a5e8575d136195eb8d09b317ec9028f32b743e7ea1279d4b4523d4fd.jpeg",
    "https://cdn.faire.com/fastly/abbbd01e40b8a6f440ff6c1d262b8dcfa257562f373110d5773e4126d3343b68.jpeg",
  ],
  priceDollars: 47.7,
  description:
    "Knit Brushed French Terry Jogger Pants with front strap (Set#BP739, BP835)",
  tags: [],
  msrpDollars: 95.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:45.508Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
